import type { RouteRecordRaw } from 'vue-router';
import { pensionFundRoutesDictionary } from './pension-fund-routes.dictionary';

export const pensionFundRoutesConfig: RouteRecordRaw = {
  ...pensionFundRoutesDictionary.pensionFunds.root,
  redirect: { name: pensionFundRoutesDictionary.pensionFunds.list.name },
  children: [
    {
      ...pensionFundRoutesDictionary.pensionFunds.list,
      component: () => import('../pages/List/PensionFundListPage.vue'),
    },
    {
      ...pensionFundRoutesDictionary.pensionFunds.create,
      component: () => import('../pages/Create/CreatePensionFund.vue'),
    },
    {
      ...pensionFundRoutesDictionary.pensionFunds.update,
      component: () => import('../pages/Edit/EditPensionFund.vue'),
      props: true,
    },
  ],
};
